import React, { useEffect, useState } from 'react';
import { APIClient } from '../../../helpers/apiHelper';

export const api = new APIClient();

interface Study {
  studyInstanceUID: string;
  patientID: string;
  patientName: string;
  studyDate: string;
  studyTime: string;
  modality: string;
  numberOfSeries: string;
  numberOfInstances: string;
  retrieveURL: string;
}

interface PacsStudies {
  success: boolean;
  message: string;
  data: Study[];
}

interface DBStudy {
  study_instance_uid: string;
  patient_id: number;
  study_date: string;
  patient: {
    patient_id: number;
    patient_name: string;
  };
}

interface DBStudiesResponse {
  data: any[];
  total_count: number;
  has_more: boolean;
  page: number;
  items_per_page: number;
  filtered_conditions: null;
}

const PacsSync: React.FC = () => {
  const [pacsStudies, setPacsStudies] = useState<PacsStudies | null>(null);
  const [dbStudies, setDbStudies] = useState<DBStudiesResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState('');
  const [draggedStudy, setDraggedStudy] = useState<Study | null>(null);
  const [expandedStudies, setExpandedStudies] = useState<Set<string>>(
    new Set()
  );
  const [showCreatePatientModal, setShowCreatePatientModal] = useState(false);
  const [newPatientInfo, setNewPatientInfo] = useState({
    patient_id: '',
    patient_name: '',
  });
  const [selectedPatient, setSelectedPatient] = useState<null>(null);
  const [patients, setPatients] = useState<[]>([]);
  const [patientSearch, setPatientSearch] = useState('');
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const response = await api.get('/patients');
        console.log('==================== response', response);

        setPatients(response.data);
      } catch (error) {
        console.error('Error fetching patients:', error);
      }
    };
    fetchPatients();
  }, []);

  const handleDragStart = (study: Study) => (e: React.DragEvent) => {
    setDraggedStudy(study);
    e.dataTransfer.setData('text/plain', study.studyInstanceUID);
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    if (draggedStudy) {
      setShowModal(true);
    }
  };

  const fetchPacsStudies = async () => {
    try {
      const response = await api.get('/fetch-pacs-studies');
      console.log('Exams Not Synced Yet response:', response);
      setPacsStudies(response);
    } catch (error) {
      console.error('Error hitting fetch studies endpoint:', error);
      setError('Error occurred during fetch');
    } finally {
      setLoading(false);
    }
  };

  const fetchDBStudies = async () => {
    try {
      const response = await api.get('/fetch-db-studies');
      console.log('All Your Exams response:', response);
      setDbStudies(response);
    } catch (error) {
      console.error('Error hitting fetch studies endpoint 1:', error);
      setError('Error occurred during fetch 1');
    }
  };

  useEffect(() => {
    console.log('============== refresh', refreshTrigger);

    fetchPacsStudies();
    fetchDBStudies();
  }, [refreshTrigger]);

  const formatDate = (dateStr: string) => {
    if (!dateStr) return '';
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    const day = dateStr.slice(6, 8);
    return `${year}-${month}-${day}`;
  };

  const formatTime = (timeStr: string) => {
    if (!timeStr) return '';
    const hours = timeStr.slice(0, 2);
    const minutes = timeStr.slice(2, 4);
    const seconds = timeStr.slice(4, 6);
    return `${hours}:${minutes}:${seconds}`;
  };

  const truncateId = (id: string) => {
    if (!id) return '';
    return id.length > 10 ? `...${id.slice(-10)}` : id;
  };

  // const handleModalSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   if (!draggedStudy) return;

  //   try {
  //     console.log("================== draggedStudy", draggedStudy);
  //     const studyToSync = draggedStudy;
  //     if (!studyToSync) {
  //       console.error('No study to sync');
  //       return;
  //     }

  //     const studyInfo = {
  //       study_instance_uid: studyToSync.studyInstanceUID,
  //       patient_id: JSON.stringify(selectedPatient.id),
  //       series_instance_uid: studyToSync.series?.[0]?.seriesUID,
  //       sop_instance_uid: studyToSync.series?.[0]?.instances?.[0]?.instanceUID,
  //       series_modality: studyToSync.modality,
  //       frames: studyToSync.series?.[0]?.instances?.[0]?.numberOfFrames,
  //       pixel_spacing: null, // This would need to come from DICOM metadata
  //       transfer_syntax: studyToSync.series?.[0]?.instances?.[0]?.transferSyntaxUID,
  //       sop_class_uid: studyToSync.series?.[0]?.instances?.[0]?.sopClassUID,
  //       referenced_sop_uids: studyToSync.series?.flatMap(series =>
  //         series.instances?.map(inst => inst.instanceUID) || []
  //       ),
  //       instances: studyToSync.series?.flatMap(series =>
  //         series.instances?.map(inst => ({
  //           instanceUID: inst.instanceUID,
  //           sopClassUID: inst.sopClassUID,
  //           transferSyntaxUID: inst.transferSyntaxUID,
  //           instanceNumber: inst.instanceNumber,
  //           numberOfFrames: inst.numberOfFrames,
  //           retrieveURL: inst.retrieveURL
  //         })) || []
  //       )
  //     };

  //     const instances = studyInfo.instances || [];

  //     for (const instance of instances) {
  //       console.log("====================== po");

  //       const instanceStudyInfo = {
  //         ...studyInfo,
  //         sop_instance_uid: instance.instanceUID,
  //         frames: instance.numberOfFrames,
  //         transfer_syntax: instance.transferSyntaxUID,
  //         sop_class_uid: instance.sopClassUID
  //       };

  //       const formData = new FormData();
  //       formData.append('study_info', JSON.stringify(instanceStudyInfo));

  //       const response = await api.post('/sync-study', formData, {
  //         headers: {
  //           'Content-Type': 'multipart/form-data'
  //         }
  //       });

  //       if (response.status !== 200) {
  //         console.error('Failed to sync instance:', instance.instanceUID, response.data?.message);
  //         break; // Stop syncing if any instance fails
  //       }

  //     }
  //   } catch (error) {
  //     console.error('Error syncing study:', error);
  //   }
  // };

  const handleModalSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!draggedStudy) return;

    try {
      console.log('================== draggedStudy', draggedStudy);
      const studyToSync = draggedStudy;
      if (!studyToSync) {
        console.error('No study to sync');
        return;
      }

      const studyInfo = {
        study_instance_uid: studyToSync.studyInstanceUID,
        patient_id: JSON.stringify(selectedPatient.id),
        series_instance_uid: studyToSync.series?.[0]?.seriesUID,
        sop_instance_uid: studyToSync.series?.[0]?.instances?.[0]?.instanceUID,
        series_modality: studyToSync.modality,
        frames: studyToSync.series?.[0]?.instances?.[0]?.numberOfFrames,
        pixel_spacing: null,
        transfer_syntax:
          studyToSync.series?.[0]?.instances?.[0]?.transferSyntaxUID,
        sop_class_uid: studyToSync.series?.[0]?.instances?.[0]?.sopClassUID,
        referenced_sop_uids: studyToSync.series?.flatMap(
          (series) => series.instances?.map((inst) => inst.instanceUID) || []
        ),
        instances: studyToSync.series?.flatMap(
          (series) =>
            series.instances?.map((inst) => ({
              instanceUID: inst.instanceUID,
              sopClassUID: inst.sopClassUID,
              transferSyntaxUID: inst.transferSyntaxUID,
              instanceNumber: inst.instanceNumber,
              numberOfFrames: inst.numberOfFrames,
              retrieveURL: inst.retrieveURL,
            })) || []
        ),
      };

      const instances = studyInfo.instances || [];
      let syncSuccess = true;

      for (const instance of instances) {
        console.log('====================== po');

        const instanceStudyInfo = {
          ...studyInfo,
          sop_instance_uid: instance.instanceUID,
          frames: instance.numberOfFrames,
          transfer_syntax: instance.transferSyntaxUID,
          sop_class_uid: instance.sopClassUID,
        };

        const formData = new FormData();
        formData.append('study_info', JSON.stringify(instanceStudyInfo));

        const response = await api.post('/sync-study', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('==================== test', response);

        if (response.status_code !== 200) {
          console.error(
            'Failed to sync instance:',
            instance.instanceUID,
            response.data?.message
          );
          syncSuccess = false;
          break;
        }
      }

      console.log('==================== test1 ', syncSuccess);

      if (syncSuccess) {
        // 1. Trigger refetch first
        setRefreshTrigger((prev) => prev + 1);

        // 2. Wait for the data to update (optional delay for effect)
        await new Promise((resolve) => setTimeout(resolve, 500));

        // 3. Finally, close the modal
        setShowModal(false);
      }
    } catch (error) {
      console.error('Error syncing study:', error);
    }
  };

  const getUnsyncedStudies = (pacsStudies: Study[], dbStudies: DBStudy[]) => {
    if (!pacsStudies || !dbStudies) return [];

    // Create a Set of study UIDs from the database
    const dbStudyUIDs = new Set(
      dbStudies.map((study) => study.study_instance_uid)
    );

    // Filter PACS studies that are not in the database
    return pacsStudies.filter(
      (study) => !dbStudyUIDs.has(study.studyInstanceUID)
    );
  };

  const toggleStudy = (studyUID: string) => {
    setExpandedStudies((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(studyUID)) {
        newSet.delete(studyUID);
      } else {
        newSet.add(studyUID);
      }
      return newSet;
    });
  };

  return (
    <div className="mx-auto flex h-full flex-col overflow-scroll">
      <div className="p-4 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg shadow-md mb-4 mx-auto text-center max-w-2xl">
        <p className="text-blue-900 text-lg font-medium leading-relaxed">
          At left are all your not synced exams that were loaded to Deepecho via
          PACS to PACS. To fully benefit from Deepecho features, you should
          integrate those exams to the platform by dragging them and dropping to
          join your existing exams.
        </p>
      </div>

      <div className="flex flex-row gap-4 p-4 h-full">
        {/* Exams Not Synced Yet Accordion */}
        <div className="flex-1 border-2 border-blue-200 rounded-lg p-4 h-full">
          <h2 className="text-lg font-bold mb-2 text-blue-800">
            Exams Not Synced Yet
          </h2>
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : pacsStudies ? (
            <div className="mt-4 h-[calc(100%-40px)] overflow-y-auto">
              {getUnsyncedStudies(pacsStudies.data, dbStudies?.data || []).map(
                (study, index) => (
                  <div
                    key={index}
                    className="mb-2 border-2 border-blue-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                    draggable
                    onDragStart={handleDragStart(study)}
                  >
                    <div
                      className="p-4 bg-blue-50 flex justify-between items-center cursor-pointer hover:bg-blue-100 transition-colors"
                      onClick={() => toggleStudy(study.studyInstanceUID)}
                    >
                      <span className="font-medium text-blue-900">
                        {study.studyInstanceUID}
                      </span>
                      <svg
                        className={`w-4 h-4 transition-transform text-blue-700 ${
                          expandedStudies.has(study.studyInstanceUID)
                            ? 'rotate-180'
                            : ''
                        }`}
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    {expandedStudies.has(study.studyInstanceUID) && (
                      <div className="p-4 bg-blue-50">
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <span className="font-medium text-blue-800">
                              Patient Name:
                            </span>{' '}
                            <span className="text-blue-900">
                              {study.patientName}
                            </span>
                          </div>
                          <div>
                            <span className="font-medium text-blue-800">
                              Patient ID:
                            </span>{' '}
                            <span className="text-blue-900">
                              {truncateId(study.patientID)}
                            </span>
                          </div>
                          <div>
                            <span className="font-medium text-blue-800">
                              Study Date:
                            </span>{' '}
                            <span className="text-blue-900">
                              {formatDate(study.studyDate)}
                            </span>
                          </div>
                          <div>
                            <span className="font-medium text-blue-800">
                              Study Time:
                            </span>{' '}
                            <span className="text-blue-900">
                              {formatTime(study.studyTime)}
                            </span>
                          </div>
                          <div>
                            <span className="font-medium text-blue-800">
                              Modality:
                            </span>{' '}
                            <span className="text-blue-900">
                              {study.modality}
                            </span>
                          </div>
                          <div>
                            <span className="font-medium text-blue-800">
                              Series:
                            </span>{' '}
                            <span className="text-blue-900">
                              {study.numberOfSeries}
                            </span>
                          </div>
                          <div>
                            <span className="font-medium text-blue-800">
                              Instances:
                            </span>{' '}
                            <span className="text-blue-900">
                              {study.numberOfInstances}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )
              )}
            </div>
          ) : null}
        </div>

        {/* All Your Exams Accordion */}
        <div
          className="flex-1 border-2 border-green-200 rounded-lg p-4 h-full"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <h2 className="text-lg font-bold mb-2 text-green-800">
            All Your Exams
          </h2>
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : dbStudies ? (
            <div className="mt-4 h-[calc(100%-40px)] overflow-y-auto">
              {dbStudies.data.length > 0 ? (
                dbStudies.data.map((study, index) => (
                  <div
                    key={index}
                    className="mb-2 border-2 border-green-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                  >
                    <div
                      className="p-4 bg-green-50 flex justify-between items-center cursor-pointer hover:bg-green-100 transition-colors"
                      onClick={() => toggleStudy(study.study_instance_uid)}
                    >
                      <span className="font-medium text-green-900">
                        {study.study_instance_uid}
                      </span>
                      <svg
                        className={`w-4 h-4 transition-transform text-green-700 ${
                          expandedStudies.has(study.study_instance_uid)
                            ? 'rotate-180'
                            : ''
                        }`}
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    {expandedStudies.has(study.study_instance_uid) && (
                      <div className="p-4 bg-green-50">
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <span className="font-medium text-green-800">
                              Patient Name:
                            </span>{' '}
                            <span className="text-green-900">
                              {study.patient.patient_name}
                            </span>
                          </div>
                          <div>
                            <span className="font-medium text-green-800">
                              Patient ID:
                            </span>{' '}
                            <span className="text-green-900">
                              {truncateId(study.patient.patient_id.toString())}
                            </span>
                          </div>
                          <div>
                            <span className="font-medium text-green-800">
                              Study Date:
                            </span>{' '}
                            <span className="text-green-900">
                              {formatDate(study.study_date)}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="p-4 text-center text-green-800">
                  No studies found
                </div>
              )}
            </div>
          ) : null}
        </div>
      </div>

      {/* Modal for drag-and-drop confirmation */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-10 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-1/3">
            <h3 className="text-lg font-bold mb-4">Assign Study to Patient</h3>
            <div className="space-y-4">
              {/* Patient Search and Selection */}
              <div>
                <div className="max-h-40 overflow-y-auto border rounded">
                  {patients?.items?.map((patient) => (
                    <div
                      key={patient.patient_id}
                      className={`p-2 cursor-pointer ${
                        selectedPatient?.patient_id === patient.patient_id
                          ? 'bg-blue-300 hover:bg-blue-400'
                          : 'hover:bg-gray-100'
                      }`}
                      onClick={() => {
                        if (
                          selectedPatient?.patient_id === patient.patient_id
                        ) {
                          setSelectedPatient(null);
                        } else {
                          setSelectedPatient(patient);
                        }
                      }}
                    >
                      <div className="font-medium">{patient.patient_name}</div>
                      <div className="text-sm text-gray-600">
                        ID: {patient.patient_id}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Divider */}
              <div className="border-t my-4"></div>

              {/* Create New Patient Section */}
              {/* <h4 className="text-md font-bold mb-2">Or Create New Patient</h4>
              <div>
                <label className="block text-sm font-medium mb-1">Patient ID</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded"
                  value={newPatientInfo.patient_id}
                  onChange={(e) => setNewPatientInfo(prev => ({
                    ...prev,
                    patient_id: e.target.value
                  }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Patient Name</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded"
                  value={newPatientInfo.patient_name}
                  onChange={(e) => setNewPatientInfo(prev => ({
                    ...prev,
                    patient_name: e.target.value
                  }))}
                />
              </div> */}

              {/* Modal Actions */}
              <div className="flex justify-end gap-2">
                <button
                  className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className={`bg-blue-500 text-white font-bold py-2 px-4 rounded ${
                    !selectedPatient
                      ? 'opacity-50 cursor-not-allowed'
                      : 'hover:bg-blue-700'
                  }`}
                  onClick={handleModalSubmit}
                  disabled={!selectedPatient}
                >
                  Sync
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PacsSync;
